import { render, staticRenderFns } from "./CustomTargetSystem.vue?vue&type=template&id=653ac559&"
import script from "./CustomTargetSystem.vue?vue&type=script&lang=js&"
export * from "./CustomTargetSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports